import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import { registryToast } from './components/toast' // message 提示消息插件
import jiankongdata from './components/jiankongdata/jiankongdata.js'
function getCookie (cookiename) {
  var allcookies = document.cookie
  // 索引长度，开始索引的位置
  var cookiepos = allcookies.indexOf(cookiename)
  // 如果找到了索引，就代表cookie存在,否则不存在
  if (cookiepos !== -1) {
  // 把cookie_pos放在值的开始，只要给值加1即可
  // 计算取cookie值得开始索引，加的1为“=”
    cookiepos = cookiepos + cookiename.length + 1
    // 计算取cookie值得结束索引
    var cookieend = allcookies.indexOf(';', cookiepos)
    if (cookieend === -1) {
      cookieend = allcookies.length
    }
    // 得到想要的cookie的值
    var value = unescape(allcookies.substring(cookiepos, cookieend))
  }
  return value
}
function getQueryString () {
  var url2 = window.location.href
  var temp2 = url2.split('?yonghuming=')
  return temp2[1]
}
function getyonghuming () {
  let yonghuming = getQueryString()
  const cookieyonghuming = getCookie('yonghuming')
  yonghuming = cookieyonghuming || yonghuming
  return yonghuming
}
// function fontsize (a) { const fontsize = a;return fontsize }
Vue.use(registryToast)
Vue.prototype.$axios = axios
Vue.prototype.$getyonghuming = getyonghuming
Vue.prototype.$jiankongdata = jiankongdata
// Vue.prototype.$fontsize = fontsize // 设字体用于调大小

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
